module.exports = "Current Group ID,New Group ID\ngroup-1,group-1-rename\n"